import { Grid, theme } from "antd";
import React from "react";

import {
  HeaderBodyText,
  HeaderSubText,
  HeaderSuperText,
  HeaderText,
  LocationListingsOverlayChild,
} from "./styled";

export const Header: React.FC = () => {
  const breakpoints = Grid.useBreakpoint();
  const { token } = theme.useToken();

  return (
    <LocationListingsOverlayChild
      $token={token}
      $breakpoints={breakpoints}
      style={{ marginBottom: "1rem" }}
    >
      <HeaderSuperText $token={token} $breakpoints={breakpoints}>
        {"Find a store"}
      </HeaderSuperText>
      <HeaderText>{"EquipmentShare Locations"}</HeaderText>
      <HeaderBodyText $token={token}>
        {
          "Browse EquipmentShare's 326+ locations in 44 states to rent equipment, manage your assets and reduce your downtime."
        }
      </HeaderBodyText>
      <HeaderSubText $token={token} href="/directory">
        {"View Directory"}
      </HeaderSubText>
    </LocationListingsOverlayChild>
  );
};
